






import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class RunStatus extends Vue {
  /**
   *  bgc 圆圈背景颜色
   *  color 文字颜色
   *  title 文本内容
   */

    @Prop({ default: 'bgc52c41a' }) bgc!: string
    @Prop({ default: 'color52c41a' }) color!: string
    @Prop({ default: '运行中' }) title!: string
}
